import api from './api'

/**
 * Serviço de PDI (Plano de Desenvolvimento Individual)
 */
export default {
  /**
   * Listar PDIs
   */
  list(params = {}) {
    return api.get('/api/pdis', { params })
  },

  /**
   * Criar PDI
   */
  create(pdiData) {
    return api.post('/api/pdis', pdiData)
  },

  /**
   * Atualizar PDI completo
   */
  update(id, pdiData) {
    return api.put(`/api/pdis/${id}`, pdiData)
  },

  /**
   * Atualizar status do PDI
   */
  updateStatus(id, status, rejectionReason = null) {
    let url = `/api/pdis/${id}/status?status=${status}`
    if (rejectionReason) {
      url += `&rejectionReason=${encodeURIComponent(rejectionReason)}`
    }
    return api.put(url)
  },

  /**
   * Deletar PDI (apenas DRAFT ou PENDING_APPROVAL)
   */
  async delete(id) {
    try {
      const response = await api.delete(`/api/pdis/${id}`)
      // Backend retorna 204 No Content em caso de sucesso
      return { success: true, status: response.status }
    } catch (error) {
      // Se o erro for 204, na verdade é sucesso
      if (error.response && error.response.status === 204) {
        return { success: true, status: 204 }
      }
      throw error
    }
  },
}
